import { brandsOpenApi, ROUTE_PATHS } from '@constants';
import { PLATFORM_NAME } from '@enums';
import { axiosBoa, isIframe } from '@utils';

export const platformHandlers = {
    async bigcommerce({ setOauthPayload, navigate, me, oauthPayload, isUserExist }) {
        const hasUser = await isUserExist();

        if (!hasUser && !me) {
            return navigate(ROUTE_PATHS.REQUEST_ACCESS);
        }

        if (!me) {
            return navigate(ROUTE_PATHS.LOGIN);
        }

        if (oauthPayload && me) {
            const response = await axiosBoa.get(brandsOpenApi.auth.platformCallback(PLATFORM_NAME.BIGCOMMERCE), {
                params: oauthPayload
            });

            if (response.ok) {
                if (isIframe()) {
                    return navigate(ROUTE_PATHS.APP_EMBEDDED);
                }

                setOauthPayload(null);

                return navigate(ROUTE_PATHS.HOME + '/?setup=1');
            }
        }

        return navigate(ROUTE_PATHS.APP_EMBEDDED);
    },

    async shopify({ getEcommerceRedirect, setEmbeddedLoadPayload, searchParams, navigate }) {
        const shop = searchParams.get('shop');
        const isEmbedded = searchParams.has('embedded');
        const showModalSetup = searchParams.has('setup');

        if (!isEmbedded) {
            const status = await getEcommerceRedirect(PLATFORM_NAME.SHOPIFY, {
                nonce: null,
                shop,
                token_type: 'offline'
            });

            if (!status) {
                setEmbeddedLoadPayload(null);
                return navigate(ROUTE_PATHS.REGISTER);
            }

            return status;
        }

        return navigate(ROUTE_PATHS.APP_EMBEDDED, { state: { showModalSetup } });
    }
};
